<template>
  <multiselect 
    placeholder="Select Report Type"
    :options="reports" 
    label="name" 
    track-by="type" 
    :value="selected" 
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>
        {{ props.option.name }}
      </div>
    </template>
  </multiselect>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ReportTypeSelect',

  components: {
    Multiselect
  },

  props: ['value'],

  computed: {
    ...mapState(['reportTypes']),

    reports () {
      let reports = []
      this.reportTypes.sections.forEach((section) => {
        section.reports.forEach((report) => {
          reports.push(report)
        })
      })
      return reports.sort((a, b) => {
        if (a.type < b.type) { return -1 }
          if (a.type > b.type) { return 1 }
            return 0
        })
    },

    selected () {
      return this.reports.find(report => report.type === this.value)
    }
  },

  methods: {
    handleInput (value) {
      this.$emit('input', value.type)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>